import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";
import { WithholdingGroupService } from "../../services/withholding-group.service";
import { findWithholdingGroupAct, loadWithholdingGroupByIdAct, saveWithholdingGroupAct, saveSuccessWithholdingGroupAct, 
    setViolationsWithholdingGroupAct, showMsgErrorAct, updateWithholdingGroupAct, updateSuccessWithholdingGroupAct } from "./withholding-group.action";


@Injectable()
export class WithholdingGroupEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private withholdingGroupService = inject(WithholdingGroupService);
    private alerta = inject(AlertaService);

    findWithholdingGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findWithholdingGroupAct),
            exhaustMap(action => this.withholdingGroupService.findWithholdingGroupById(action.id)
                .pipe(
                    map(withholdingGroup => loadWithholdingGroupByIdAct({ withholdingGroup })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/withholdingsGroup']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveWithholdingGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveWithholdingGroupAct),
            exhaustMap(action => this.withholdingGroupService.createWithholdingGroup(action.withholdingGroupNew)
                .pipe(
                    map(withholdingGroupNew => saveSuccessWithholdingGroupAct({ withholdingGroupNew })),
                    catchError(error => (error.status == 400) ? of(setViolationsWithholdingGroupAct({ withholdingGroupForm: action.withholdingGroupNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))
                    
                    )
                )
            )
        )
    );

    showMsgErrorEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(showMsgErrorAct),
          tap(action => {
            const detail = action.error?.error?.message || action.error?.message || null;
            //console.log('showMsgErrorEffect 111:');
            this.alerta.error(
              'Se ha presentado un error interno Grupo Beneficios',
              detail ? { detail } : undefined
            );
            //console.log('showMsgErrorEffect 222:');
          })
        ),
        { dispatch: false }
      );

    saveSuccessWithholdingGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessWithholdingGroupAct),
        tap(() => {
            this.router.navigate(['/withholdingsGroup']);
            this.alerta.correct("Grupo Beneficios creado con exito!");
        })
    ), { dispatch: false });

    updateWithholdingGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateWithholdingGroupAct),
            exhaustMap(action => this.withholdingGroupService.updateWithholdingGroup(action.withholdingGroupUpdated)
                .pipe(
                    map(withholdingGroupUpdated => updateSuccessWithholdingGroupAct({ withholdingGroupUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsWithholdingGroupAct({ withholdingGroupForm: action.withholdingGroupUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessWithholdingGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessWithholdingGroupAct),
        tap(() => {
            this.router.navigate(['/withholdingsGroup']);
            this.alerta.correct("rupo Beneficios editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
    
}